import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import ProtectedRoute from './ProtectedRoute'
import {
  UserSettings,
  PasswordReset,
  PasswordResetConfirmation,
  AcceptInvitation,
  SetupMFA,
  SetupMFAWebAuthn,
  SetupMFATOTP,
  DisableMFA,
  ChangePassword,
  SetupMFAEnforced
} from '../../containers'
import * as routes from '../../constants/routes'

const createRoutes = () => (
  <Switch>
    <ProtectedRoute
      exact
      path={routes.CHANGE_PASSWORD}
      component={ChangePassword}
    />
    <ProtectedRoute
      exact
      path={routes.SETUP_WEB_AUTHN}
      component={SetupMFAWebAuthn}
    />
    <ProtectedRoute exact path={routes.SETUP_TOTP} component={SetupMFATOTP} />
    <ProtectedRoute
      exact
      path={routes.SETUP_MFA_ENFORCED}
      component={SetupMFAEnforced}
    />
    <ProtectedRoute exact path={routes.SETUP_MFA} component={SetupMFA} />
    <ProtectedRoute exact path={routes.DISABLE_MFA} component={DisableMFA} />
    <Route exact path={routes.SETTINGS} component={UserSettings} />
    <Route exact path={routes.PASSWORD_RESET} component={PasswordReset} />
    <Route
      path={routes.PASSWORD_RESET_CONFIRMATION}
      component={PasswordResetConfirmation}
    />
    <Route path={routes.ACCEPT_INVITATION} component={AcceptInvitation} />
    <Redirect to={routes.SETTINGS} />
  </Switch>
)

export default createRoutes
